import React from "react";
import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import { Section, SectionHeading, Reveal } from "../lib/ui";
import { OWNERS } from "../config";

function OwnerCard({ owner, index }) {
  return (
    <Reveal delay={index * 0.12}>
      <div className="group hairline rounded-2xl bg-ink-surface/60 overflow-hidden hover:border-gold/40 transition-colors duration-500 h-full flex flex-col" data-testid={`owner-card-${index}`}>
        <div className="relative overflow-hidden">
          <div className="absolute -inset-2 bg-gold/5 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
          <img
            src={owner.photo}
            alt={owner.name}
            className="relative w-full h-[420px] object-cover object-top grayscale-[15%] group-hover:grayscale-0 transition-all duration-700"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent" />
          <div className="absolute bottom-5 left-6 right-6">
            <div className="overline text-gold mb-1.5">{owner.title}</div>
            <h3 className="font-display font-light text-3xl text-white">{owner.name}</h3>
          </div>
        </div>

        <div className="p-6 md:p-8 flex flex-col flex-1">
          <div className="flex flex-wrap gap-2 mb-5">
            {owner.focus.map((f) => (
              <span key={f} className="rounded-full border border-silver/20 bg-white/[0.03] px-3 py-1 text-xs font-body text-silver/70">{f}</span>
            ))}
          </div>
          <p className="text-silver/70 font-body font-light text-sm leading-relaxed flex-1">{owner.bio}</p>

          <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3">
            <a href={`mailto:${owner.email}`} className="group/link inline-flex items-center gap-2 text-sm font-body text-silver/80 hover:text-gold transition-colors" data-testid={`owner-email-${index}`}>
              <span className="h-9 w-9 rounded-full border border-gold/30 flex items-center justify-center text-gold shrink-0"><Mail size={15} /></span>
              <span className="truncate">{owner.email}</span>
            </a>
            <a href={`tel:${owner.phone.replace(/[^+\d]/g, "")}`} className="inline-flex items-center gap-2 text-sm font-body text-silver/80 hover:text-gold transition-colors" data-testid={`owner-phone-${index}`}>
              <span className="h-9 w-9 rounded-full border border-gold/30 flex items-center justify-center text-gold shrink-0"><Phone size={15} /></span>
              <span>{owner.phone}</span>
            </a>
          </div>
        </div>
      </div>
    </Reveal>
  );
}

export function Leadership() {
  return (
    <Section id="leadership" className="bg-ink-surface">
      <SectionHeading
        overline="Leadership & Ownership"
        title={<>Founded and owned by <span className="gold-text">two partners.</span></>}
        kicker="Arco Orbis2 is co-founded and jointly owned by Mike Rush and Frank Shaw — two British military veterans who lead every engagement personally."
        align="center"
      />
      <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
        {OWNERS.map((o, i) => (
          <OwnerCard key={o.name} owner={o} index={i} />
        ))}
      </div>
    </Section>
  );
}
